import apiFetch from '../apiFetch'

export default function (idCliente, token) {
  return apiFetch({endPoint: `Cliente/getCliente?idCliente=` + idCliente, method: 'GET', body: null, token: token})
}